var AutoLinker = require('autolinker');
var Formatter = require('formatter');
var User = require("user");
var util = require("../lib/util.es6");


var BufferFormatter = function (buffer) {
    this.buffer = buffer;
    this.linker = new AutoLinker(this);
};
BufferFormatter.prototype = util.inherit(Formatter, {
    linkNick: function (nick, options) {
        var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
            nick: nick
        });
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.attr = options.attr || {};
        options.attr['role'] = 'button';
        options.attr['aria-controls'] = 'memberContextMenu';
        options.attr['aria-haspopup'] = 'true';
        options.className += ' user';
        options.button = 'span';
        return this.linkModel(user, options);
    },
    linkChannel: function (name, options) {
        var buffer = this.buffer.connection.makeChannel({name: name});
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.className += ' channel';
        return this.linkModel(buffer, options);
    },
    linkBuffer: function (name, options) {
        var buffer = this.buffer.connection.makeChild({name: name});
        return this.linkModel(buffer, options);
    },
    link: function (options) {
        return this.linkModel(this.buffer, options);
    },
    linkConnection: function (options) {
        return this.linkModel(this.buffer.connection, options);
    },
    linkServer: function (serverName, options) {
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.className += ' server';
        options.name = serverName;
        return this.linkModel(this.buffer.connection, options);
    },
    spanMessageUser: function (nick, message, options) {
        var user = message.makeUser(nick);
        if (options.color && !message.isSelf()) {
            if (!options.className) {
                options.className = '';
            }
            options.className += ' bufferSpan c' + this.getNickColorIndex(
                message.getDisplayAuthor() || nick
            );
        }
        var attrs = {
            title: user.getTitle(),
            'class': options.className
        };
        var html = '<span' + this.makeAttributes(attrs) + '>';
        html += this.escapeText(user.getName());
        html += '</span>';
        return html;
    },
    linkMessageUser: function (nick, message, options) {
        var user = message.makeUser(nick);
        options = options || {};
        if (options.color && !message.isSelf()) {
            if (!options.className) {
                options.className = '';
            }
            options.className += ' c' + this.getNickColorIndex(
                message.getDisplayAuthor() || nick
            );
        }
        if (!options.hasDataParent && message.id) {
            options.data = _.extend({}, options.data, {
                eid: message.id
            });
        }
        return this.linkUserMode(user, options);
    },
    linkUser: function (user, options) {
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.attr = options.attr || {};
        options.attr['role'] = 'button';
        options.attr['aria-controls'] = 'memberContextMenu';
        options.attr['aria-haspopup'] = 'true';
        options.className += ' user';
        var data = {};
        if (options.hasDataParent) {
            options.className += ' hasUserParent';
        } else {
            data.usermask = user.get('usermask');
            data.name = user.getName();
        }
        if (!options.noData) {
            data.ident_prefix = user.get('ident_prefix');
            data.user = user.get('user');
            data.userhost = user.get('userhost');
            data.mode = user.get('newmode') || user.get('mode');
            data.account = user.get('account');
            data.realname = user.getRealname();
            data.avatar = user.get('avatar');
            data.avatar_url = user.get('avatar_url');
            data.display_name = user.get('display_name');
            data.bot_url = user.get('bot_url');
        }
        options.data = _.extend({}, options.data, data);
        options.button = 'span';
        var prefix = (options.prefix || '');
        return prefix + this.linkModel(user, options);
    },
    makeUserMode: function (user, options) {
        options = options || {};
        var modeSymbol = '';
        var modePill = '';
        if (!options.noMode && user && user.getMode()) {
            if (!options.className) {
                options.className = '';
            }
            var modeClass = 'mode_' + user.getModeCategory();
            options.className += ' moded ' + modeClass;
            modeSymbol += '<span title="' + user.getModeTitle() + '" class="mode_prefix mode_symbol ' + modeClass + '">' + this.escapeText(user.getModeSymbol()) + '</span>';
            modePill += '<span title="' + user.getModeTitle() + '" class="mode_prefix mode_pill ' + modeClass + '">•</span>';
        }
        return modeSymbol + modePill;
    },
    linkUserMode: function (user, options) {
        options = options || {};
        var userMode = this.makeUserMode(user, options);
        options.prefix = (options.prefix || '') + userMode;
        return this.linkUser(user, options);
    },
    getDummyUserFromModeSymbol: function (symbol) {
        var prefixes = this.buffer.connection.getISupport('PREFIX') || User.defaultPrefixes;
        for (var letter in prefixes) {
            if (prefixes[letter] == symbol) {
                return new User({
                    mode: letter
                }, {
                    session: this.buffer.session,
                    connection: this.buffer.connection,
                    buffer: this.buffer
                });
            }
        }
    }
});

module.exports = BufferFormatter;



//////////////////
// WEBPACK FOOTER
// ./app/src/format/bufferformatter.js
// module id = gfb+
// module chunks = 1